//@flow
import React from 'react';
import i18n from 'app/common/lib/i18n';
import makeRecipeTimeText from 'app/common/lib/util/makeRecipeTimeText';
import { secondsToRoundedHoursMinutes } from 'app/packages/recipe-star-components/utils';
import { Box, Icon, Text } from 'gestalt';

type Props = {|
  richSummary: {
    display_cook_time?: number,
  },
|};

export default function RecipeSummary({ richSummary }: Props) {
  return (
    <Box display="flex">
      {!!richSummary.display_cook_time && (
        <Box alignItems="center" display="flex">
          <Icon
            icon="clock"
            accessibilityLabel={i18n._('cooking time', 'time it takes to cook a recipe')}
            color="darkGray"
            size={10}
            inline
          />
          <Box paddingX={1}>
            <Text inline size="sm">
              {!!richSummary.display_cook_time &&
                makeRecipeTimeText(secondsToRoundedHoursMinutes(richSummary.display_cook_time))}
            </Text>
          </Box>
        </Box>
      )}
    </Box>
  );
}
